import { useParams } from 'react-router-dom'
import { useUserProfile } from 'src/features/user'
import { FormSkeleton } from 'src/pages/budget/components'
import {
  useCreateContextGate,
  useCurrentRequest,
  useRequestByIdGate,
} from 'src/pages/budget/budgetRequests/hooks'
import { RequestPayload } from 'src/pages/budget/budgetRequests/types'
import { RequestWidget } from 'src/pages/budget/budgetRequests/widgets'
import {
  ModalRequestsApprove,
  ModalRequestsReject,
} from 'src/pages/budget/budgetRequests/components'
import { useCeoTeam } from 'src/pages/budget/hook'
import { trimDecimalTrailingZeros } from 'src/pages/budget/budgetRequests/currency'

export const EditRequest = () => {
  const { id } = useParams<{ id: string }>()
  const userProfile = useUserProfile()
  const { ceoTeam } = useCeoTeam()
  const isCeo = ceoTeam.includes(userProfile.id)

  useCreateContextGate()
  useRequestByIdGate(id)

  const request = useCurrentRequest()

  if (!request) {
    return <FormSkeleton />
  }

  const mode =
    request.createdBy.id === userProfile.id ? 'editOwn' : 'editForApprove'

  const initialValues: Partial<RequestPayload> = {
    isEarlyPayment: request.isEarlyPayment ?? undefined,
    budgetPeriod: request.budgetPeriod.id,
    team: request.team.id,
    article: request.article.id,
    articleItem: request.articleItem.id,
    description: request.description,
    amount: trimDecimalTrailingZeros(request.amount),
    currency: request.currency,
    costByCountryEnabled: request.costByCountryEnabled,
    costByCountry: request.costByCountry.map((item) => ({
      ...item,
      amount: trimDecimalTrailingZeros(item.amount),
    })),
    productIds: request.productIds,
    autoPaymentEnabled: request.autoPaymentEnabled,
    autoPaymentFrequency: request.autoPaymentFrequency,
    status: request.status,
    createdBy: request.createdBy,
    comment: request.comment,
    availableApprovalSteps: request.availableApprovalSteps,
  }

  return (
    <>
      <RequestWidget initialValues={initialValues} mode={mode} isCeo={isCeo} />
      <ModalRequestsApprove />
      <ModalRequestsReject />
    </>
  )
}
